import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { BASE_URL } from '../../constants/Common';
import auth from './../Authentication/Authenticate';

class User extends React.Component {

    constructor() {
        super()
        this.state = {
            isHidden: true
        }
    }
    toggleHidden = () => {
        this.setState({
            isHidden: !this.state.isHidden
        })
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    handleClick = (e) => {
        if (this.node.contains(e.target)) {
            return;
        }
        this.setState({ isHidden: true });
    }

    logout = (e) => {
        e.preventDefault()
        auth.logout()
    }

    Child = user_info => {
        if (JSON.stringify(user_info) === '{}') {
			return (
                <ul className="dropdown-menu">
                    <li onClick={this.toggleHidden}><Link to="/login">Đăng nhập</Link></li>
                </ul>
            )
        }
        return (
            <ul className="dropdown-menu">
                <li onClick={this.toggleHidden}><Link to={`/profile/${user_info.id}`}>{user_info.fullname}</Link></li>
                <li onClick={this.toggleHidden} className="coin"><img src={BASE_URL + 'images/coin.png'} alt="coin" />{user_info && user_info.scoin ? user_info.scoin + ' Scoins' : '0 Scoin'}</li>
                <li onClick={this.toggleHidden}><Link to="/scoin">Nạp Scoin</Link></li>
                <li onClick={this.toggleHidden}><Link to="/purchase-day">Nạp Ngày</Link></li>
                {!user_info.is_vip ? <li onClick={this.toggleHidden}><Link to="/account-vip">Mua VIP</Link></li> : null}
                <li onClick={this.toggleHidden}><Link to="/histories">Lịch sử</Link></li>
                <li onClick={this.toggleHidden}><Link to="/logout" onClick={this.logout}>Đăng xuất</Link></li>
            </ul>
        );
    }

    render() {
        let { user_info } = this.props;
        return (
            <Fragment>
                <li>
                    <Link to="/packages" className="link-package">Gói dịch vụ</Link>
                </li>
                <li className="dropdown header-user" ref={node => this.node = node}>
                    <a onClick={this.toggleHidden} className="avatar dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                        <img src={user_info && user_info.avatar ? user_info.avatar : BASE_URL + 'images/icon-user.png'} alt="user avatar" className="img-circle" />
                    </a>
                    {!this.state.isHidden && this.Child(user_info)}
                </li>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user_info: state.root.users
    }
}

export default connect(mapStateToProps)(User);



// WEBPACK FOOTER //
// ./src/components/MainPanel/User.js